import { Command, CommandResult } from '@/_core/cqrs/types/commands';

export class RevokeMcpConsentCommand extends Command<CommandResult> {
    constructor(public AuthorizationId: string) {
        super('RevokeMcpConsent');
    }
}
